/**
 * Do not edit directly
 * Generated on Thu, 29 Sep 2022 18:15:25 GMT
 */

export const componentSnackbarContainerAlignHorizontal = "center";
export const componentSnackbarContainerAlignVertical = "flex-end";
export const componentSnackbarContainerZIndex = "600";
export const componentSnackbarContainerPaddingBottomBS = "0.5rem";
export const componentSnackbarContainerPaddingBottomBM = "1rem";
export const componentSnackbarContainerPaddingHorizontal = "1rem";
export const componentSnackbarContainerPaddingTop = 0;
export const componentSnackbarContainerStateEnterOpacity = 0;
export const componentSnackbarContainerStateEnterActiveTransition = "opacity 0.5s ease-in"; // opacity 0.5s ease-in
export const componentSnackbarContainerStateEnterActiveOpacity = 1;
export const componentSnackbarContainerStateExitOpacity = 1;
export const componentSnackbarContainerStateExitActiveTransition = "opacity 0.75s ease-in"; // opacity 0.75s ease-in
export const componentSnackbarContainerStateExitActiveOpacity = 0;
export const componentSnackbarSnackAlignVertical = "flex-start";
export const componentSnackbarSnackBackgroundColor = "#2e2f32";
export const componentSnackbarSnackBorderRadius = "0.25rem";
export const componentSnackbarSnackElevation = "0 0.3125rem 0.625rem 0.1875rem rgba(0, 0, 0, 0.15), 0 -0.0625rem 0.25rem 0 rgba(0, 0, 0, 0.10)";
export const componentSnackbarSnackMaxWidthBS = "21.4375rem";
export const componentSnackbarSnackMaxWidthBM = "none"; // TODO: figure this out
export const componentSnackbarSnackActionFontFamily = "Bogle, 'Helvetica Neue', Helvetica, Arial, sans-serif";
export const componentSnackbarSnackActionFontSize = "0.875rem";
export const componentSnackbarSnackActionFontWeight = "400";
export const componentSnackbarSnackActionHeight = "3.25rem";
export const componentSnackbarSnackActionPaddingHorizontal = "0.5rem";
export const componentSnackbarSnackActionPaddingVertical = 0;
export const componentSnackbarSnackActionTextColor = "#fff";
export const componentSnackbarSnackActionTextDecoration = "underline";
export const componentSnackbarSnackActionWhiteSpace = "nowrap"; // TODO: figure this out
export const componentSnackbarSnackCloseBorderRadius = "0.25rem";
export const componentSnackbarSnackCloseHeight = "3.25rem";
export const componentSnackbarSnackCloseIconColor = "#fff";
export const componentSnackbarSnackCloseIconName = "Close";
export const componentSnackbarSnackCloseIconSize = "small";
export const componentSnackbarSnackCloseWidth = "3rem";
export const componentSnackbarSnackMessageFontFamily = "Bogle, 'Helvetica Neue', Helvetica, Arial, sans-serif";
export const componentSnackbarSnackMessageFontSize = "0.875rem";
export const componentSnackbarSnackMessageFontWeight = "400";
export const componentSnackbarSnackMessageLineHeight = "1.25rem";
export const componentSnackbarSnackMessagePadding = "1rem";
export const componentSnackbarSnackMessageTextColor = "#fff";